import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { PrivacyComponent } from './pages/terms/privacy.component';
import { HttpService } from './core/services/http.service';
import { SitesTerms } from './pages/terms/sites_terms.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./account/account.module').then(m => m.AccountModule),
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'terms/privacy',
    component: PrivacyComponent,
  },
  {
    path: 'terms/sites_terms',
    component: SitesTerms,
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      relativeLinkResolution: 'legacy',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private router: Router, private http: HttpService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.logging();
      }
    });
  }

  logging() {
    const id = localStorage.getItem('email');
    const token = localStorage.getItem('token');
    if (!id || !token) return;

    this.http.post('/log_history', {
      user_id: id,
      requested_url: location.href,
      header_info: '',
      body_info: '',
    });
  }
}
